import _ from 'lodash';
import { apiFetch } from './utility';

export const LOGIN_REQUESTED = 'auth/LOGIN_REQUESTED';
export const LOGIN_SUCCESS = 'auth/LOGIN_SUCCESS';
export const LOGIN_SUCCESS_MOBILE = 'auth/LOGIN_SUCCESS_MOBILE';
export const AUTH_SUCCESS = 'auth/AUTH_SUCCESS';
export const LOGIN_FAILURE = 'auth/LOGIN_FAILURE';
export const LOGOUT = 'auth/LOGOUT';

const initialState = {
	accessToken: undefined,
	accessIsForMobile: undefined,
	isAuthenticating: false,
	authSuccess: false,
	authFailure: false,
	authErrors: [],
};

const init = (state = initialState, action) => {
	switch (action.type) {
		case LOGIN_REQUESTED:
			return {
				...state,
				isAuthenticating: true,
				authErrors: [],
				authFailure: false,
				authSuccess: false,
			};

		case AUTH_SUCCESS:
			return {
				...state,
				authUser: action.authUser,
				isAuthenticating: false,
				authSuccess: true,
				authFailure: false,
			};

		case LOGIN_SUCCESS:
			return {
				...state,
				accessToken: action.accessToken,
				accessIsForMobile: action.accessIsForMobile,
				authUser: action.authUser,
				isAuthenticating: false,
				authSuccess: true,
				authFailure: false,
			};

		case LOGIN_FAILURE:
			return {
				...state,
				accessToken: undefined,
				accessIsForMobile: undefined,
				authErrors: action.errors,
				isAuthenticating: false,
				authSuccess: false,
				authFailure: true,
			};

		case LOGOUT:
			return {
				...state,
				accessToken: undefined,
				accessIsForMobile: undefined,
			};

		default:
			return state;
	}
};
export default init;

export const authenticate = ({ accessToken }) => {
	return (dispatch) => {
		apiFetch({
			method: 'user.authenticate',
			skipErrors: true,
			params: { accessToken },
			dispatch,
			callback: function (errors, r) {
				if (errors && errors.length) {
					dispatch({
						type: LOGIN_FAILURE,
						errors,
					});
					return;
				}

				const authUser = _.get(r, ['collections', 'userCollection', 0]);
				if (!authUser) {
					dispatch({
						type: LOGIN_FAILURE,
						errors: ['Server did not return authUser'],
					});
					return;
				}

				//- its all good
				dispatch({
					type: AUTH_SUCCESS,
					accessToken,
					authUser,
				});
			},
		});
	};
};

export const login = ({ username, password, browserAuthCode, userAgent, timeClockLocationId }) => {
	return (dispatch) => {
		dispatch({
			type: LOGIN_REQUESTED,
		});

		const params = {
			username,
			password,
			browserAuthCode,
			userAgent,
			timeClockLocationId,
		};

		setTimeout(function () {
			apiFetch({
				method: 'user.login',
				skipErrors: true,
				params,
				dispatch,
				callback: function (errors, r) {
					handleLogin({ errors, r, dispatch, accessIsForMobile: false });
				},
			});
		}, 500);
	};
};

export const mobileLogin = ({ username, password, deviceToken }) => {
	return (dispatch) => {
		dispatch({
			type: LOGIN_REQUESTED,
		});

		const params = {
			username,
			password,
			deviceToken,
		};

		setTimeout(function () {
			apiFetch({
				method: 'user.mobileLogin',
				skipErrors: true,
				params,
				dispatch,
				callback: function (errors, r) {
					handleLogin({ errors, r, dispatch, accessIsForMobile: true });
				},
			});
		}, 500);
	};
};

function handleLogin({ errors, r, dispatch, accessIsForMobile }) {
	if (errors && errors.length) {
		dispatch({
			type: LOGIN_FAILURE,
			errors,
		});
		return;
	}

	const accessToken = r.accessToken;
	const authUser = _.get(r, ['collections', 'userCollection', 0]);

	if (!accessToken) {
		dispatch({
			type: LOGIN_FAILURE,
			errors: ['Server did not return accessToken'],
		});
		return;
	}

	if (!authUser) {
		dispatch({
			type: LOGIN_FAILURE,
			errors: ['Server did not return authUser'],
		});
		return;
	}

	//- its all good
	dispatch({
		type: LOGIN_SUCCESS,
		accessToken,
		accessIsForMobile,
		authUser,
	});
}

export const logout = (p) => {
	return (dispatch) => {
		const deviceToken = p ? p.deviceToken : undefined;

		if (!deviceToken) {
			dispatch({
				type: LOGOUT,
			});
			return;
		}

		/**
		 * Users with deviceToken means they are on the new sphere mobile
		 * and we want to track which device they are on
		 */
		apiFetch({
			method: 'user.mobileLogout',
			skipErrors: true,
			params: {
				deviceToken,
			},
			dispatch,
			callback: function (errors) {
				dispatch({
					type: LOGOUT,
				});
				if (errors) {
					console.error('mobileLogout', errors);
				}
			},
		});
	};
};
